import $ from "jquery";
import gsap from "gsap";
import AsseetsManager from "../pixi/AssetsManager";

/**
 * Introクラス
 */
class Intro {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //DOM
  private _intro: JQuery;

  // ---------------------------------------------------------------------------------------------------------
  // --	Intro
  // ---------------------------------------------------------------------------------------------------------
  /**
   * コンストラクタ
   */
  constructor() {
    this._intro = $(".c-intro");
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	ACTION
  // ----------------------------------------------------------------------------------------------------------------

  /**
   * スタート
   */
  start(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._intro.find(".c-intro__btn-on").on("click", (e) => {
        e.preventDefault();
        AsseetsManager.instance.playSound("sound_click");
        resolve();
      });
      this._intro.find(".c-intro__btn-off").on("click", (e) => {
        e.preventDefault();
        AsseetsManager.instance.soundMute(true);
        resolve();
      });
    });
  }

  /**
   * 破棄
   */
  destroy(): void {
    this._intro.find(".c-intro__btn-on").off("click");
    this._intro.find(".c-intro__btn-off").off("click");
    this._intro.remove();
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Intro;
